import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Clickwrap from 'components/Clickwrap';
import APFormGroup from 'components/FormFields/APFormGroup';

import './styles.scss';

const NotificationPreferences = ({
  title,
  introText,
  categories,
  items,
  savePreferences,
}) => {
  const [notifications, setNotifications] = useState(items);

  useEffect(() => {
    setNotifications(items);
  }, [items]);

  const onChangeClickwrap = (event, notificationType) => {

    const notification = { ...notifications };
    if (notificationType === 'email') {
      if (!notification[event].email){
        notification[event] = {
          email: true,
          notify: true,
        };
      } else {
        notification[event] = {
          email: !notification[event].email,
          notify: notification[event].notify,
        };
      }
    } else if (notificationType === 'notify') {
      if (notification[event].notify) {
        notification[event] = {
          email: false,
          notify: false,
        };
      } else {
        notification[event] = {
          email: notification[event].email,
          notify: !notification[event].notify,
        };
      }
    }
    setNotifications(notification);
    savePreferences(notification);
  };

  const renderCategory = (index, category) => {
    return (
      <div
        key={`category-${index}`}
        className="settings-grid__group"
      >
        <div className="settings-grid__category">{category.name}</div>
        {category.prefs.map((pref) => renderRow(pref))}
      </div>
    );
  };

  const renderRow = (pref) => {
    const row = notifications[pref.key];
    return (
      <div
        key={pref.key}
        className="settings-grid__row"
      >
        <div className="settings-grid__cell">
          <p>{pref.name}</p>
        </div>
        <div className="settings-grid__cell">
          <Clickwrap
            name={`${pref.key}-notify`}
            checked={row?.notify}
            isDisabled={pref?.disabled}
            disabled={pref?.disabled}
            className="clickwrap--view-option small"
            labelClassName={pref?.disabled ? 'settings-clickwrap-disabled' : ''}
            onChange={() => onChangeClickwrap(pref.key, 'notify')}
          />
        </div>
        <div className="settings-grid__cell">
          <Clickwrap
            name={`${pref.key}-email`}
            checked={row?.email}
            isDisabled={pref?.disabled}
            disabled={pref?.disabled}
            className="clickwrap--view-option small"
            labelClassName={pref?.disabled ? 'settings-clickwrap-disabled' : ''}
            onChange={() => onChangeClickwrap(pref.key, 'email')}
          />
        </div>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <>
        <APFormGroup
          title={title}
          grid={false}
        >
          <div className="settings-grid settings-grid--notifications">
            <p className="settings-notifications__intro">{introText}</p>
            <div className="settings-grid__header">
              <div className="settings-grid__row">
                <div className="settings-grid__cell">
                  <h4 className="settings-grid__heading">Notification Type</h4>
                </div>
                <div className="settings-grid__cell center">
                  <h4 className="settings-grid__heading">In App</h4>
                </div>
                <div className="settings-grid__cell center">
                  <h4 className="settings-grid__heading">Email</h4>
                </div>
              </div>
            </div>
            <div className="settings-grid__settings">
              {categories.map((category, index) => renderCategory(index, category))}
            </div>
          </div>
        </APFormGroup>
      </>
    );
  };

  return renderForm();
};

NotificationPreferences.propTypes = {
  id: PropTypes.number,
  pushNotification: PropTypes.func,
};

NotificationPreferences.defaultProps = {};

export default NotificationPreferences;
